const noop = () => {};
/**
 * 重复执行 fn 直到 untilFn 返回值为 true
 * @argument {number} times 最大执行次数
 * @argument {number} interval 上一次请求完成后到下一次请求开始的时间间隔
 * @argument {context} fn 执行时的作用域
 */

export default (fn, { times = 10, interval = 1000, untilFn = noop, context } = {}) => (...rest) => {
    let attempt = 1;
    const command = {
        stop: false,
    };

    const execute = () => {
        const promise = new Promise((resolve, reject) => {
            const retryAttempt = () => {
                if (command.stop) {
                    return;
                }
                fn.apply(context, rest)
                    .then(data => {
                        const until = untilFn(data);
                        if (!until && attempt++ < times) {
                            setTimeout(retryAttempt, interval);
                        } else {
                            resolve(data);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            };

            retryAttempt();
        });

        return promise;
    };

    const stop = () => {
        command.stop = true;
    };

    return { execute, stop };
};
